import { IntegrityMonitorRealTimePanelController } from '../controller/IntegrityMonitorRealTimePanelController';
import { IntegrityMonitorMode, IntegrityMonitorRealTimeSection } from '@nirvana/shared/dtos/types/policies/common';
import { BaseFormFieldWebComponentElement } from '../../../../../framework/BaseFormFieldWebComponentElement';

export class IntegrityMonitorRealTimePanelWebComponent extends BaseFormFieldWebComponentElement<IntegrityMonitorRealTimeSection> {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrityMonitorRealTimePanelController,
    });
  }

  /**
   * This method is called from ExtJs at validity checking of the entire Policy record form
   */
  public isValid(): boolean {
    const formValue = this.getFormValue() as IntegrityMonitorRealTimeSection;

    if (!formValue || !formValue.enabled) {
      return true;
    }

    if (formValue.mode === IntegrityMonitorMode.RULE_SETS) {
      return formValue.ruleSetIds.length > 0;
    }

    // Additional validations regarding Baselines could be implemented here in the future
    return true;
  }
}
